export default "__VITE_ASSET__B7l8fkEA__"